import bodyPng from "./peek-body.png";
import frontPng from "./peek-front.png";

/**
 * Heidi peeking round a corner, in two layers cut down the line her paws
 * grip: the `front` (head, scarf and both paws) goes over the target and the
 * `body` behind it, so she reads as hiding behind it rather than stuck on in
 * front.
 */
export function PeekMascot({ layer, className }: { layer: "front" | "body"; className?: string }) {
  return <img className={className} src={layer === "front" ? frontPng : bodyPng} alt="" draggable={false} />;
}
